/**
 * Web Style Import
 *
 */

import './style/dnb-test-element.scss'
